import { ErrorContent } from '../../components/layouts'

export default function AuthorityError() {
  return <ErrorContent
    title='Unauthorized'
    subtitle='このページにアクセスする権限がありません'
    message='システム管理者に連絡してください。'
    returnToBefore={true} />
}
